import { Grid, IconButton, Tooltip } from '@mui/material'
import { useEffect, useState } from 'react'
import { MdAdd, MdArrowBack, MdDelete } from 'react-icons/md'
import Programa from '../../../components/Programa/Programa'
import Edicao from './Edicao'
import PrimeTable from '../../../components/PrimeTable'
import { IoReload } from 'react-icons/io5'
import { metodoPrograma } from '../../../components/api'
import { setSuccess } from '../../../components/alerts'
import ModalConfirmacao from '../../utils/modal/ModalConfirmacao'
import { useModal } from '../../../components/Utils/UseModal'

export const listaSituacao = [
  ['0', 'Criada'],
  ['1', 'Iniciada'],
  ['9', 'Concluída'],
  ['C', 'Cancelada'],
]

export const STATUS_MAP = {
  0: { label: 'Criada', color: '#1976d2', background: '#e3f2fd' },
  1: { label: 'Iniciada', color: '#ff9800', background: '#fff3e0' },
  9: { label: 'Concluída', color: '#2e7d32', background: '#e8f5e9' },
  C: { label: 'Cancelada', color: '#c62828', background: '#ffebee' },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status // fallback

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        color: info.color,
        backgroundColor: info.background,
      }}
    >
      {info.label}
    </span>
  )
}

const ManutencaoEquipamento = () => {
  const [tela, setTela] = useState('lista')
  const [ferramentas, setFerramentas] = useState()
  const [dados, setDados] = useState(null)
  const [atualiza, setAtualiza] = useState(true)
  const openModal = useModal(ModalConfirmacao)

  const voltar = () => {
    setTela('lista')
    setDados(undefined)
    setAtualiza((v) => !v)
  }

  const exclui = (manutencao) => async (e) => {
    e.stopPropagation()

    e.stopPropagation()
    if (
      await openModal({
        titulo: `Mas você tem CERTEZA que deseja ${manutencao[10] ? 'ativar' : 'excluir'} "${manutencao[1]}" ?`,
      })
    ) {
      setSuccess(
        `Equipamento: ${manutencao[1]} ${manutencao[10] ? 'ativado' : 'excluido'} com sucesso!`,
      )
      await metodoPrograma('exclui', { idManutencao: manutencao[0] })
      setAtualiza((v) => !v)
    }
  }

  const handleClick = (linha) => {
    setDados(linha)
    setTela('opcoes')
  }

  useEffect(() => {
    switch (tela) {
      case 'lista':
        setFerramentas(
          <Tooltip title="Adicionar">
            <IconButton onClick={() => setTela('opcoes')}>
              <MdAdd />
            </IconButton>
          </Tooltip>,
        )
        break
      case 'opcoes':
        setFerramentas(
          <Tooltip title="Voltar">
            <IconButton onClick={voltar}>
              <MdArrowBack />
            </IconButton>
          </Tooltip>,
        )
        break
      default:
        break
    }
  }, [tela])

  return (
    <Programa codigo="CtrlManutencaoEquipamento" ferramentas={ferramentas}>
      {tela === 'lista' ? (
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <PrimeTable
              codigo="CtrlManutencaoEquipamento"
              action="lista"
              habSearch={true}
              rows={10}
              refresh={atualiza}
              collumnsDate={[3, 4]}
              collumnsCurrency={[5]}
              head={[
                'Titulo',
                'Equipamento',
                'Status',
                'Previsão Início',
                'Conclusão',
                'Orçamento',
                '',
              ]}
              line={(item) => [
                item[1],
                item[5]?.[1],
                item[3] ? <StatusChip status={item[3]} /> : '',
                item[7],
                item[8],
                item[6],
                '',
              ]}
              columnOptions={[
                {
                  alias: 8,
                  customJsx: ({ linhaOriginal }) => (
                    <IconButton size="small" onClick={exclui(linhaOriginal)}>
                      {linhaOriginal[10] ? <IoReload /> : <MdDelete />}
                    </IconButton>
                  ),
                },
              ]}
              onRowSelect={handleClick}
            />
          </Grid>
        </Grid>
      ) : (
        <Edicao {...{ dados, voltar, setTela }} />
      )}
    </Programa>
  )
}

export default ManutencaoEquipamento
